"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestsLoader = void 0;
const pino_1 = __importDefault(require("pino"));
const react_router_1 = require("react-router");
const appConstants_1 = require("../../../constants/appConstants");
const conversationApprovalQuery_1 = require("../../../queries/approvals/conversationApprovalQuery");
const companyQuery_1 = require("../../../queries/companyQuery");
const conversationQuery_1 = require("../../../queries/conversationQuery");
const currenciesQuery_1 = require("../../../queries/currenciesQuery");
const requestListQuery_1 = require("../../../queries/requestListQuery");
const teamQuery_1 = require("../../../queries/teamQuery");
const userQuery_1 = require("../../../queries/userQuery");
const userSelectors_1 = require("../../../selectors/userSelectors");
const logger = (0, pino_1.default)();
const requestsLoader = async ({ queryClient, params }) => {
    let conversationApproval = null;
    let requestId = params.requestId;
    const user = await queryClient.ensureQueryData(userQuery_1.userQuery);
    const teams = await queryClient.ensureQueryData(teamQuery_1.allTeamsQuery);
    const currencies = await queryClient.ensureQueryData((0, currenciesQuery_1.getCurrenciesQuery)(undefined));
    const companyPropertiesData = await queryClient.ensureQueryData((0, companyQuery_1.companyPropertiesQuery)(user?.companyAccountId, {
        defaultExpirationDate: 'tsgo-virtualcardexprange',
        companyApprovalLimit: 'tsgo-requestlimit',
        cardprovider: 'tsgo-cardprovider',
    }));
    if (params.approvalId) {
        // we want to view the approval conversation
        const conversationApprovalQueryFn = (0, conversationApprovalQuery_1.conversationApprovalQuery)(params.approvalId);
        conversationApproval = await queryClient.ensureQueryData(conversationApprovalQueryFn);
        let requestIdFromLocalStorage = '';
        try {
            // this is the last chane to render in view the approval conversation
            // but we might not have the create card button visible
            requestIdFromLocalStorage = globalThis.localStorage.getItem('conversationId') || '';
        }
        catch {
            requestIdFromLocalStorage = '';
        }
        requestId = conversationApproval ? conversationApproval?.request.requestId : requestIdFromLocalStorage || '';
    }
    const requestQuery = (0, requestListQuery_1.getRequestQuery)(requestId);
    const eventsQuery = (0, conversationQuery_1.getEventsQuery)({ conversationId: requestId || '', polling: false });
    const requestData = await queryClient.ensureQueryData({
        queryKey: requestQuery.queryKey,
        queryFn: requestQuery.queryFn,
    });
    if ((0, userSelectors_1.isCompanyAdmin)(user.roles) && requestData?.state === appConstants_1.requestStatus.CREATED) {
        /*
         * Company admin is not allowed to view a created request but not submitted.
         * If accessed directly from browser address bar, redirect to error page.
         */
        throw (0, react_router_1.redirect)('/error');
    }
    let eventsData;
    try {
        eventsData = await queryClient.ensureQueryData({
            queryKey: eventsQuery.queryKey,
            queryFn: eventsQuery.queryFn,
        });
    }
    catch (error) {
        logger.error({ error });
        eventsData = { data: null, error, isError: true };
    }
    return {
        user,
        teams,
        requestData,
        conversationApproval,
        eventsData,
        approvalId: params.approvalId,
        currencies,
        companyPropertiesData,
    };
};
exports.requestsLoader = requestsLoader;
